import { render, staticRenderFns } from "./ZiyaretRaporu.vue?vue&type=template&id=4994fb2e&scoped=true"
import script from "./ZiyaretRaporu.vue?vue&type=script&lang=js"
export * from "./ZiyaretRaporu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4994fb2e",
  null
  
)

export default component.exports